module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_plugin_buffering__;